export default "__VITE_ASSET__2Q5OnvuQ__"